const Name = (props) => {
    return (
        <div className='nameContainer'>
            <div className='name'>
                John Hwang
            </div>
            <div>
                <a href='mailto:john@podeux.com' className='contact'>
                    john@podeux.com
                </a>
            </div>
        </div>
    );
};

export default Name;